<div [ngSwitch]="inputData.fieldType">
  <!-- TEXT -->
  <input
    *ngSwitchCase="'TEXT'"
    pInputText
    ngModel
    [attr.id]="inputData.key"
    [attr.name]="inputData.key"
    name="{{ inputData.key }}"
    type="search"
    (keyup.enter)="onFilter(inputData.key, $event.target.value)"
    placeholder="{{ inputData?.additionalData?.placeholder || '' }}"
  />
  <!-- SINGLE_SELECT -->
  <p-dropdown
    *ngSwitchCase="'SINGLE_SELECT'"
    [options]="inputData.additionalData.listData"
    (onChange)="
      selectedValue(inputData.key, inputData.additionalData.optionLabel, $event)
    "
    placeholder="{{ inputData.additionalData.placeholder }}"
    optionLabel="{{ inputData.additionalData.optionLabel }}"
    showClear="true"
  ></p-dropdown>
  <!--MULTI SELECT -->
  <p-multiSelect
    *ngSwitchCase="'MULTI_SELECT'"
    defaultLabel="{{ inputData.additionalData.placeholder }}"
    [attr.id]="inputData.key"
    [attr.name]="inputData.key"
    [options]="inputData.additionalData.listData"
    [(ngModel)]="multiSelectValues"
    tooltipPosition="bottom"
    appendTo="body"
    optionLabel="{{ inputData.additionalData.optionLabel }}"
    (onChange)="
      getMultiSelectValues(
        $event,
        inputData.key,
        inputData.additionalData.selectedKey
      )
    "
  ></p-multiSelect>
  <!--    AUTO_COMPLETE-->
  <p-autoComplete
    *ngSwitchCase="'AUTO_COMPLETE'"
    [(ngModel)]="autoCompleteValues"
    name="{{ inputData.key }}"
    id="{{ inputData.key }}"
    [suggestions]="inputData.additionalData.listData"
    (completeMethod)="
      getDataBySearch(
        $event,
        inputData.additionalData.url,
        inputData.additionalData.urlParamKey,
        inputData.additionalData.listData
      )
    "
    (onSelect)="
      getSelectedValues(
        $event,
        inputData.key,
        inputData.additionalData.selectedKey
      )
    "
    (onUnselect)="
      getSelectedValues(
        $event,
        inputData.key,
        inputData.additionalData.selectedKey
      )
    "
    placeholder="{{ inputData.additionalData.placeholder }}"
    [multiple]="true"
    field="{{ inputData.additionalData.optionLabel }}"
  ></p-autoComplete>
  <!-- DATE_RANGE -->
  <p-calendar
    *ngSwitchCase="'DATE_RANGE'"
    [(ngModel)]="rangeDates"
    placeholder="{{ inputData?.additionalData?.placeholder }}"
    (onSelect)="
      applyDateRangeValues(
        $event,
        inputData.additionalData.fromKey,
        inputData.additionalData.toKey
      )
    "
    selectionMode="range"
    [readonlyInput]="true"
    [showIcon]
    [dateFormat]="'dd M'"
    [hideOnDateTimeSelect]="true"
  ></p-calendar>

  <div class="ui-g-12 ui-md-4" *ngSwitchCase="'DELAY'" class="delay-section">
    <div class="ui-inputgroup delay-group-box">
      <p-dropdown
        class="delay-dropdown"
        [options]="inputData.additionalData.listData"
        [(ngModel)]="delayRangeType"
        placeholder="Select"
      ></p-dropdown>
      <input
        type="search"
        class="delay-text"
        pInputText
        [(ngModel)]="delayRangeValue"
        (keyup.enter)="onFilterByDelay()"
      />
    </div>
  </div>
</div>
